import { cn } from './chunk-FFX3LZW7.js';
import * as React from 'react';
import * as SeparatorPrimitive from '@radix-ui/react-separator';
import { jsx } from 'react/jsx-runtime';

var Separator = React.forwardRef(function Separator2({ className, orientation = "horizontal", decorative = true, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    SeparatorPrimitive.Root,
    {
      ref,
      decorative,
      orientation,
      className: cn(
        "shrink-0 bg-border",
        orientation === "horizontal" ? "h-[1px] w-full" : "h-full w-[1px]",
        className
      ),
      ...props
    }
  );
});

export { Separator };
//# sourceMappingURL=chunk-NCCYLVD3.js.map
//# sourceMappingURL=chunk-NCCYLVD3.js.map